module.exports = __webpack_public_path__ + "img/2973702.289aa9dc.png";